import { Path } from "../js/path.js";

const myMouse = new Path();
export default myMouse;